/**
 * One-line context above the legacy Login/Register forms when the visitor was sent there by a
 * page that needs an account, so the switch in look doesn't read as a detour (or a phish).
 * Legacy styling on purpose: these forms live outside the developer design system.
 */
import React from 'react';

const REASONS = {
  '/oauth/authorize': {
    login: 'Sign in to finish connecting an app to Everscope.',
    register: 'Create an account to finish connecting an app to Everscope.',
    after: "You'll come straight back to the request.",
  },
  '/account/developer': {
    login: 'Sign in to manage your API keys and connected apps.',
    register: 'Create an account to get API keys and connect assistants.',
    after: "You'll go straight to Developer settings.",
  },
};

export default function SignInReason({ from, mode = 'login' }) {
  const path = String((from && from.pathname) || '').replace(/\/+$/, '');
  const reason = REASONS[path];
  if (!reason) return null;
  return (
    <div role="note" className="mb-6 rounded-md border border-blue-200 bg-blue-50 px-4 py-3 text-sm text-blue-900">
      <p className="font-semibold">{reason[mode]}</p>
      <p className="mt-0.5">{reason.after}</p>
    </div>
  );
}
